var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),type = locals_.type,message = locals_.message;
var jade_indent = [];
buf.push("\n<div class=\"flash\">\n  <div" + (jade.cls(['alert','alert-dissmiable',"alert-" + (type ? type : 'info') + ""], [null,null,true])) + ">\n    <button type=\"button\" data-dismiss=\"alert\" class=\"close\">&times;</button>\n    <p>" + (jade.escape((jade_interp = message) == null ? '' : jade_interp)) + "</p>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}